import menu from 'assets/icons/menu.png';
import { screenHeadersData } from 'data/ScreensData/screenData';
import { OverlayPanel } from 'primereact/overlaypanel';
import { MegaMenu } from 'primereact/megamenu';
import classes from './menuPopover.module.scss';
import { useMenuPopover } from './useMenuPopover';
import { useNavigate } from 'react-router-dom';
import { useMemo, useCallback } from 'react';
import { MenuItemCommandEvent } from 'primereact/menuitem';
import { observer } from 'mobx-react';
import { useStore } from 'hooks/useStore';

const MenuPopOver = observer(function MenuPopOver() {
  const { FeatureFlagStore } = useStore();
  const { op, handleMenuClick } = useMenuPopover();
  const navigate = useNavigate();

  const handleSubmenuClick = useCallback((e: React.MouseEvent) => {
    // Prevent default behavior and stop propagation to avoid closing the overlay
    e.preventDefault();
    e.stopPropagation();
  }, []);

  const items = useMemo(() => {
    return screenHeadersData
      .filter(item => !item.featureFlag || FeatureFlagStore.isEnabled(item.featureFlag))
      .map(item => ({
      label: (
        <div
          onClick={e => {
            e.stopPropagation(); // Prevent event bubbling
            if (!item.disabled) {
              navigate(item.route || '');
            }
          }}
        >
          {item.screenName}
        </div>
      ),
      icon: (
        <img
          src={item.icon}
          alt={item.screenName}
          className={classes.menuIcon}
          onClick={e => {
            e.stopPropagation(); // Prevent event bubbling
            if (!item.disabled) {
              navigate(item.route || '');
            }
          }}
        />
      ),

      disabled: item.disabled,
      command: (_e: MenuItemCommandEvent) => {
        // console.log(e);
        // console.log("Parent item clicked", item.screenName);
        // if (item.route && !item.disabled) {
        //   navigate(item.route);
        // }
      },
      items: item.children?.map(child => {
        let route = '';
        // Map child items to their corresponding routes from Navigations.tsx
        switch (child.screenName) {
          case 'Active Drug Strategy':
            route = '/facts/active_drug_strategy';
            break;
          case 'Drug Portfolio Management':
            route = '/facts/drug_portfolio_management';
            break;
          case 'Sales Plan':
            route = '/fdp/target_market';
            break;
          case 'Unconstrained Forecast':
            route = '/fdp/unconstrained_forecast';
            break;
          case 'Constrained Forecast':
            route = '/fdp/constrained_forecast';
            break;
          case 'Supplier Forecast':
            route = '/fdp/supplier_forecast';
            break;
          case 'Provisional Forecast':
            route = child.route || '/fdp/provisonal_forecast';
            break;
          case 'Opportunity Tracker':
            route = '/bdportal/optracker/board';
            break;
          default:
            route = child.route || '';
        }

        return {
          label: (
            <div
              onClick={e => {
                e.stopPropagation(); // Prevent event bubbling
                if (route && !child.disabled) {
                  navigate(route);
                }
              }}
            >
              {child.screenName}
            </div>
          ),
          icon: <img src={item.icon} alt={child.screenName} className={classes.menuIcon} />,
          disabled: child.disabled,
          command: (e: MenuItemCommandEvent) => {
            e.originalEvent?.stopPropagation(); // Prevent event bubbling
            console.log('Child item clicked', child.screenName, route);
            if (route && !child.disabled) {
              navigate(route);
            }
          },
        };
      }),
    }));
  }, [navigate, FeatureFlagStore]);

  return (
    <div className={classes.menuButton}>
      <div onClick={handleMenuClick} className={classes.menuButtonIconWrapper}>
        <img className={classes.menuButtonIcon} src={menu} alt="menu" />
      </div>
      <OverlayPanel ref={op} className={classes.menuOverlay}>
        <MegaMenu
          model={items as any}
          orientation="vertical"
          breakpoint="960px"
          className={classes.megaMenu}
          onClick={handleSubmenuClick}
        />
      </OverlayPanel>
    </div>
  );
});

export default MenuPopOver;
